import { DocsPdfPage } from "./pdf/DocsPdf.dto";

export enum DocumentAccessRequesterType {
  Signer = "SIGNER",
  Referrer = "REFERRER",
}

/** eConsent 파일에 관한 정책  */
export class EconsentFileCriteria {
  /** 이메일에 첨부되는 이미지 최대 허용 용량 */
  static EMAIL_IMAGE_MAX_LIMIT_IN_MB = 5;
  /** 대상자 대량 등록 시 업로드할 엑셀 파일의 최대 허용 용량  */
  static SUBJECTS_BULK_UPLOAD_MAX_LIMIT_IN_MB = 10;
  /** 대상자 대량 등록 시 허용할 대상자 수 */
  static SUBJECTS_BULK_UPLOAD_MAX_SUBJECTS = 1000;
}

/** eConsent sms, email 입력에 관한 정책 */
export class EconsentSmsCriteria {
  /** 문자에 첨부되는 내용의 최대 길이 */
  static SMS_MESSAGE_MAX_LENGTH = 800;
  /** 문자에 첨부되는 ICF title의 최대 길이 */
  static ICF_TITLE_MAX_LENGTH = 50;
}

export interface GetDocumentSignDocsPdfPageRequest {
  token: string;
  docsPdfId: bigint;
  page: number;
  documentAccessRequesterType?: DocumentAccessRequesterType;
  documentId?: bigint;
}

export interface GetDocumentSignDocsPdfPageResponse {
  docsPdfPage: DocsPdfPage;
}
